import React from 'react';
import cn from 'clsx';
import styles from './style.module.scss';
import { useTranslation } from '@hooks/index';

const CharactersValidationHint = ({ length, max }: { length: number; max: number }) => {
    const { t } = useTranslation();
    const isLimitExceeded = length > max;

    return (
        <div className={cn('k-display-flex k-justify-content-between k-mt-1', styles.charactersValidationHint)}>
            <div>{isLimitExceeded && <span className={cn(styles.exceeded)}>{t('limitExceeded')}</span>}</div>
            <span>
                <span
                    className={cn(isLimitExceeded && styles.exceeded)}
                    style={{ opacity: isLimitExceeded ? '100%' : '50%' }}
                >
                    {length || 0}
                </span>
                <span style={{ opacity: '50%' }}>/{max}</span>
            </span>
        </div>
    );
};

export { CharactersValidationHint };
